<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <el-radio-group
        v-model="searchCondition.status"
        size="small"
        @change="switchTabs"
      >
        <el-radio-button label="1">同城配送模板管理</el-radio-button>
        <el-radio-button label="2" v-if="!isShowBtn('threeParties:false')"
          >三方配送配置</el-radio-button
        >
      </el-radio-group>
      <el-button
        type="primary"
        size="small"
        @click="addLocalExpress"
        v-if="searchCondition.status === '1'"
        >添加同城配送</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addLocalExpress"
        v-if="
          searchCondition.status === '2' && !isShowBtn('threeParties:false')
        "
        >添加三方配送配置</el-button
      >
    </div>
    <el-table
      v-if="searchCondition.status === '1'"
      :data="expressList.records"
      stripe
      border
      ref="table"
      style="width: 100%"
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="编号"
        :index="(index) => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        prop="expressName"
        label="同城配送名称"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="expressMode"
        label="配送方式"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.expressMode === 'self_express'">自营配送</span>
          <span v-if="scope.row.expressMode === 'meituan'">美团配送</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="feeCalcMode"
        label="费用计算方式"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.feeCalcMode === 'fixed'">固定费用</span>
          <span v-if="scope.row.feeCalcMode === 'distance'">按距离收费</span>
          <span v-if="scope.row.feeCalcMode === 'weight'">按重量收费</span>
          <span v-if="scope.row.feeCalcMode === 'hybrid'">混合费用</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="lowerLimitAmount"
        label="起送价"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span>满{{ scope.row.lowerLimitAmount }}元起送</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="freeShipAmount"
        label="满额免运费"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span>满{{ scope.row.freeShipAmount }}免运费</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="enabledState"
        label="开启状态"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span
            :class="scope.row.enabledState === 'yes' ? 'success' : 'danger'"
            >{{ scope.row.enabledState === "yes" ? "开启" : "关闭" }}</span
          >
        </template>
      </el-table-column>

      <el-table-column label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-tooltip
              class="item"
              effect="light"
              content="查看"
              placement="top"
            >
              <button class="pointer mr10 no-bg" @click="toDetails(scope.row)">
                <span class="hmicon icon-chakan blue"></span>
              </button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="light"
              content="编辑"
              placement="top"
            >
              <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                <span class="hmicon icon-bianji blue"></span>
              </button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-if="searchCondition.status === '2'"
      :data="thirdExpressInfoList"
      stripe
      border
      max-height="400"
      ref="table"
      style="width: 100%"
      size="small"
      :key="Math.random()"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="编号"
        column-key="index"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="平台编码"
        prop="thirdInterfaceCode"
        column-key="thirdInterfaceCode"
      ></el-table-column>
      <el-table-column
        prop="thirdInterfaceName"
        label="平台名称"
        header-align="center"
        align="center"
        column-key="thirdInterfaceName"
      >
      </el-table-column>
      <el-table-column
        prop="thirdInterfaceAccount"
        label="APP_KEY"
        header-align="center"
        align="center"
        column-key="thirdInterfaceAccount"
      >
      </el-table-column>
      <el-table-column
        prop="thirdInterfacePassword"
        label="APP_SECRET"
        header-align="center"
        align="center"
        column-key="thirdInterfacePassword"
      >
      </el-table-column>
      <el-table-column
        prop="enabledState"
        label="开启状态"
        header-align="center"
        align="center"
        column-key="enabledState"
      >
        <template slot-scope="scope">
          <span
            :class="scope.row.enabledState === 'yes' ? 'success' : 'danger'"
            >{{ scope.row.enabledState === "yes" ? "开启" : "关闭" }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        header-align="center"
        align="center"
        column-key="createTime"
      >
      </el-table-column>
      <el-table-column label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-tooltip
              class="item"
              effect="light"
              content="查看"
              placement="top"
            >
              <button class="pointer mr10 no-bg" @click="toDetails(scope.row)">
                <span class="hmicon icon-chakan blue"></span>
              </button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="light"
              content="编辑"
              placement="top"
            >
              <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                <span class="hmicon icon-bianji blue"></span>
              </button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination" v-if="searchCondition.status === '1'">
      <el-pagination
        background
        :total="expressList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        :page-sizes="[10, 50, 100, 200]"
        layout="total,  prev, pager, next, jumper, sizes"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
    >
      <!-- 同城配送 -->
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="134px"
        v-if="searchCondition.status === '1'"
      >
        <el-form-item label="配送方式" prop="expressMode">
          <el-select
            :disabled="disabled"
            clearable
            v-model="ruleForm.expressMode"
            value-key="shopId"
            placeholder="请选择配送方法"
          >
            <el-option
              v-for="(item, i) in expressModeList"
              :key="i"
              :label="item.itemText"
              :value="item.itemValue"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="配送名称" prop="expressName">
          <el-input
            :disabled="disabled"
            clearable
            v-model="ruleForm.expressName"
            size="small"
            placeholder="请输入配送名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="费用计算方式" prop="feeCalcMode">
          <el-radio-group
            :disabled="disabled"
            v-model="ruleForm.feeCalcMode"
            @change="feeCalcModeChange"
          >
            <el-radio
              v-for="(item, i) in feeCalcModeList"
              :label="item.itemValue"
              :key="i"
              >{{ item.itemText }}</el-radio
            >
          </el-radio-group>
          <!-- 固定费用 -->
          <div v-if="costType === 'fixed'">
            <!-- 满<el-input
              clearable
              type="number"
              @mousewheel.prevent.native
              :disabled="disabled"
              style="width:100px;"
              @input="filterGt0OrFixed2('lowerLimitAmount')"
              v-model="ruleForm.lowerLimitAmount"
              size="small"
            ></el-input
            >元起送, -->
            运费<el-input
              clearable
              :disabled="disabled"
              style="width: 100px"
              v-model="ruleForm.expressFee"
              @input="filterGt0OrFixed2('expressFee')"
              size="small"
            ></el-input
            >元,包装费<el-input
              clearable
              :disabled="disabled"
              style="width: 100px"
              v-model="ruleForm.packageFee"
              @input="filterGt0OrFixed3('packageFee')"
              size="small"
            ></el-input
            >元
            <div>
              满<el-input
                type="number"
                @mousewheel.prevent.native
                clearable
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.freeShipAmount"
                @input="filterGt0OrFixed2('freeShipAmount')"
                size="small"
              ></el-input
              >元免
              <el-radio v-model="ruleForm.freeType" label="all"
                >全部运费</el-radio
              >
              <el-radio v-model="ruleForm.freeType" label="basic"
                >基础运费</el-radio
              >
              <el-radio v-model="ruleForm.freeType" label="package"
                >包装费</el-radio
              >
              <el-radio v-model="ruleForm.freeType" label="basicAndPackage"
                >基础运费+包装费</el-radio
              >
            </div>
          </div>
          <!-- 按距离收费 -->
          <div v-if="costType === 'distance'">
            <!-- 满<el-input
              type="number"
              @mousewheel.prevent.native
              clearable
              :disabled="disabled"
              style="width:100px;"
              v-model="ruleForm.lowerLimitAmount"
              @input="filterGt0OrFixed2('lowerLimitAmount')"
              size="small"
            ></el-input
            >元起送 -->
            <div>
              <el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.baseDistanceUpperLimit"
                @input="filterGt0OrFixed2('baseDistanceUpperLimit')"
                size="small"
              ></el-input
              >KM内,运费<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.expressFee"
                @input="filterGt0OrFixed2('expressFee')"
                size="small"
              ></el-input
              >元,包装费<el-input
                clearable
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.packageFee"
                @input="filterGt0OrFixed3('packageFee')"
                size="small"
              ></el-input
              >元,
            </div>
            <div>
              超出部分,每KM加价<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.overPerkmPrice"
                @input="filterGt0OrFixed2('overPerkmPrice')"
                size="small"
              ></el-input
              >元
            </div>
            <div>
              满<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.freeShipAmount"
                @input="filterGt0OrFixed2('freeShipAmount')"
                size="small"
              ></el-input
              >元免
              <el-radio v-model="ruleForm.freeType" label="all"
                >全部运费</el-radio
              >
              <el-radio v-model="ruleForm.freeType" label="basic"
                >基础运费</el-radio
              >
              <el-radio v-model="ruleForm.freeType" label="package"
                >包装费</el-radio
              >
              <el-radio v-model="ruleForm.freeType" label="basicAndPackage"
                >基础运费+包装费</el-radio
              >
            </div>
          </div>
          <!-- 按重量收费 -->
          <div v-if="costType === 'weight'">
            <!-- 满<el-input
              clearable
              type="number"
              @mousewheel.prevent.native
              :disabled="disabled"
              style="width:100px;"
              v-model="ruleForm.lowerLimitAmount"
              @input="filterGt0OrFixed2('lowerLimitAmount')"
              size="small"
            ></el-input
            >元起送 -->
            <div>
              <el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.baseWeightUpperLimit"
                @input="filterGt0OrFixed2('baseWeightUpperLimit')"
                size="small"
              ></el-input
              >KG内,运费<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.expressFee"
                @input="filterGt0OrFixed2('expressFee')"
                size="small"
              ></el-input
              >元,包装费<el-input
                clearable
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.packageFee"
                @input="filterGt0OrFixed3('packageFee')"
                size="small"
              ></el-input
              >元,
            </div>
            <div>
              超出部分,每KG加价<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.overPerkgPrice"
                @input="filterGt0OrFixed2('overPerkgPrice')"
                size="small"
              ></el-input
              >元
            </div>
            <div>
              满<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.freeShipAmount"
                @input="filterGt0OrFixed2('freeShipAmount')"
                size="small"
              ></el-input
              >元免
              <el-radio v-model="ruleForm.freeType" label="all"
                >全部运费</el-radio
              >
              <el-radio v-model="ruleForm.freeType" label="basic"
                >基础运费</el-radio
              >
              <el-radio v-model="ruleForm.freeType" label="package"
                >包装费</el-radio
              >
              <el-radio v-model="ruleForm.freeType" label="basicAndPackage"
                >基础运费+包装费</el-radio
              >
            </div>
          </div>

          <!-- 混合费用 -->
          <div v-if="costType === 'hybrid'">
            <!-- 满<el-input
              :disabled="disabled"
              clearable
              type="number"
              @mousewheel.prevent.native
              style="width:100px;"
              v-model="ruleForm.lowerLimitAmount"
              @input="filterGt0OrFixed2('lowerLimitAmount')"
              size="small"
            ></el-input
            >元起送 -->
            <div>
              <el-input
                :disabled="disabled"
                clearable
                type="number"
                @mousewheel.prevent.native
                style="width: 100px"
                v-model="ruleForm.baseDistanceUpperLimit"
                @input="filterGt0OrFixed2('baseDistanceUpperLimit')"
                size="small"
              ></el-input
              >KM内,<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.baseWeightUpperLimit"
                @input="filterGt0OrFixed2('baseWeightUpperLimit')"
                size="small"
              ></el-input
              >KG内,运费<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.expressFee"
                @input="filterGt0OrFixed2('expressFee')"
                size="small"
              ></el-input
              >元,包装费<el-input
                clearable
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.packageFee"
                @input="filterGt0OrFixed3('packageFee')"
                size="small"
              ></el-input
              >元
            </div>
            <div>
              超出部分,每KM加价<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.overPerkmPrice"
                @input="filterGt0OrFixed2('overPerkmPrice')"
                size="small"
              ></el-input
              >元,每KG加价<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.overPerkgPrice"
                @input="filterGt0OrFixed2('overPerkgPrice')"
                size="small"
              ></el-input
              >元
            </div>
            <div>
              满<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                :disabled="disabled"
                style="width: 100px"
                v-model="ruleForm.freeShipAmount"
                @input="filterGt0OrFixed2('freeShipAmount')"
                size="small"
              ></el-input
              >元免
              <el-radio v-model="ruleForm.freeType" label="all"
                >全部运费</el-radio
              >
              <el-radio v-model="ruleForm.freeType" label="basic"
                >基础运费</el-radio
              >
              <el-radio v-model="ruleForm.freeType" label="package"
                >包装费</el-radio
              >
              <el-radio v-model="ruleForm.freeType" label="basicAndPackage"
                >基础运费+包装费</el-radio
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="设置统一配送范围" prop="areaCodeRange">
          <p></p>
          <!-- <el-radio-group v-model="ruleForm.areaCodeRange">
            <el-radio label="yes" :disabled="disabled"> 统一范围 </el-radio>
            <el-radio label="no" :disabled="disabled">
              每个门店独立设置（在门店可配送地图设置）
            </el-radio>
          </el-radio-group> -->

          <div style="width: 500px; height: 400px" id="container"></div>
        </el-form-item>
        <el-form-item label="是否启用" prop="enabledState">
          <el-switch
            :disabled="disabled"
            v-model="ruleForm.enabledState"
            active-color="#2d8"
            active-text="开启"
            inactive-text="关闭"
            active-value="yes"
            inactive-value="no"
          ></el-switch>
        </el-form-item>
        <div class="flex flex-center">
          <el-button
            :disabled="disabled"
            type="primary"
            size="small"
            @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button size="small" @click="dialogVisible = false"
            >关闭</el-button
          >
        </div>
      </el-form>
      <!-- 三方配送 -->
      <el-form
        ref="ruleFormTree"
        :model="ruleFormTree"
        :rules="rulesTree"
        label-width="134px"
        v-if="searchCondition.status === '2'"
      >
        <el-form-item label="平台名称" prop="thirdInterfaceName">
          <el-input
            :disabled="disabled"
            clearable
            v-model="ruleFormTree.thirdInterfaceName"
            size="small"
            placeholder="请输入平台名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="平台编码" prop="thirdInterfaceCode">
          <el-input
            :disabled="disabled"
            clearable
            v-model="ruleFormTree.thirdInterfaceCode"
            size="small"
            placeholder="请输入平台编码"
          ></el-input>
        </el-form-item>
        <el-form-item label="APP_KEY" prop="thirdInterfaceAccount">
          <el-input
            :disabled="disabled"
            clearable
            v-model="ruleFormTree.thirdInterfaceAccount"
            size="small"
            placeholder="请输入APP_KEY"
          ></el-input>
        </el-form-item>
        <el-form-item label="APP_SECRET" prop="thirdInterfacePassword">
          <el-input
            :disabled="disabled"
            clearable
            v-model="ruleFormTree.thirdInterfacePassword"
            size="small"
            placeholder="请输入APP_SECRET"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="enabledState">
          <el-switch
            :disabled="disabled"
            v-model="ruleFormTree.enabledState"
            active-color="#2d8"
            active-text="开启"
            inactive-text="关闭"
            active-value="yes"
            inactive-value="no"
          ></el-switch>
        </el-form-item>
        <!-- <div class="flex flex-center">
          <el-button
            v-if="!disabled"
            :disabled="disabled"
            type="primary"
            size="small"
            @click="submitForm('ruleFormTree')"
            >保存</el-button
          >
          <el-button size="small" @click="dialogVisible = false"
            >关闭</el-button
          >
        </div> -->
      </el-form>
      <span
        slot="footer"
        class="dialog-footer flex flex-center"
        v-if="searchCondition.status === '2'"
      >
        <el-button
          v-if="!disabled"
          :disabled="disabled"
          type="primary"
          size="small"
          @click="submitFormThree('ruleFormTree')"
          >保存</el-button
        >
        <el-button @click="dialogVisible = false" size="small" type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    const patternAreaCodeRangeFunc = function (rule, val, callback) {
      if (val === "yes") {
        if (this.ruleForm.regionType === "circular") {
          if (!this.ruleForm.areaCodeCenter || !this.ruleForm.areaCodeRadius) {
            return callback(new Error("请设置可配送范围"));
          }
        } else if (this.ruleForm.regionType === "polygon") {
          if (!this.ruleForm.areaCodeRegion) {
            return callback(new Error("请设置可配送范围"));
          }
        }
      }
      // this.ruleForm.areaCodeCenter
      //   this.ruleForm.areaCodeRadius
      callback();
    }.bind(this);
    const patternPointsRatioFunc = function (rule, val, callback) {
      if (val === "fixed") {
        if (
          // this.ruleForm.lowerLimitAmount == "" ||
          this.ruleForm.expressFee == "" ||
          this.ruleForm.freeShipAmount == ""
        ) {
          return callback(new Error("请填写所有项"));
        }
      } else if (val === "hybrid") {
        if (
          // this.ruleForm.lowerLimitAmount == "" ||
          this.ruleForm.baseDistanceUpperLimit == "" ||
          this.ruleForm.baseWeightUpperLimit == "" ||
          this.ruleForm.overPerkmPrice == "" ||
          this.ruleForm.overPerkgPrice == "" ||
          this.ruleForm.expressFee == "" ||
          this.ruleForm.freeShipAmount == ""
        ) {
          return callback(new Error("请填写所有项"));
        }
      } else if (val === "distance") {
        if (
          // this.ruleForm.lowerLimitAmount == "" ||
          this.ruleForm.baseDistanceUpperLimit == "" ||
          this.ruleForm.overPerkmPrice == "" ||
          this.ruleForm.expressFee == "" ||
          this.ruleForm.freeShipAmount == ""
        ) {
          return callback(new Error("请填写所有项"));
        }
      } else if (val === "weight") {
        if (
          // this.ruleForm.lowerLimitAmount == "" ||
          this.ruleForm.baseWeightUpperLimit == "" ||
          this.ruleForm.overPerkgPrice == "" ||
          this.ruleForm.expressFee == "" ||
          this.ruleForm.freeShipAmount == ""
        ) {
          return callback(new Error("请填写所有项"));
        }
      }

      callback();
    }.bind(this);
    return {
      thirdExpressInfoList: [],
      searchCondition: {
        status: "1",
      },
      title: "",
      disabled: false,
      pageSize: 10,
      currentPage: 1,
      dialogVisible: false,
      feeCalcModeList: [],
      ruleFormTree: {
        thirdInterfaceName: "",
        thirdInterfaceCode: "",
        thirdInterfaceAccount: "",
        thirdInterfacePassword: "",
        enabledState: "yes",
        id: "",
      },
      rulesTree: {
        thirdInterfaceName: [
          {
            required: true,
            message: "请输入平台名称",
            trigger: "blur",
          },
        ],
        thirdInterfaceCode: {
          required: true,
          message: "请输入平台编码",
          trigger: "blur",
        },
        thirdInterfaceAccount: {
          required: true,
          message: "请输入APP_KEY",
          trigger: "blur",
        },
        thirdInterfacePassword: {
          required: true,
          message: "请输入APP_SECRET",
          trigger: "blur",
        },
      },
      ruleForm: {
        expressMode: "",
        expressName: "",
        feeCalcMode: "",
        lowerLimitAmount: "",
        expressFee: "",
        freeShipAmount: "",
        baseDistanceUpperLimit: "",
        overPerkmPrice: "",
        baseWeightUpperLimit: "",
        overPerkgPrice: "",
        areaCodeRange: "yes",
        enabledState: "no",
        areaCodeCenter: "",
        areaCodeRadius: "",
        areaCodeRegion: "",
        regionType: "circular",
        localExpressId: "",
        freeType: "",
        packageFee: "",
      },
      rules: {
        expressMode: [
          {
            required: true,
            message: "请选择配送方式",
            trigger: "blur",
          },
        ],
        expressName: [
          {
            required: true,
            message: "请填写配送名称",
            trigger: "blur",
          },
          {
            min: 2,
            max: 30,
            message: "长度在 2 到 30 个字符",
            trigger: "blur",
          },
        ],
        feeCalcMode: [
          {
            required: true,
            message: "请选择费用计算方式",
            trigger: "blur",
          },
          {
            required: true,
            validator: patternPointsRatioFunc,
            trigger: "blur",
          },
        ],
        areaCodeRange: [
          {
            required: true,
            // message: "请选择费用计算方式",
            validator: patternAreaCodeRangeFunc,

            trigger: "blur",
          },
        ],
      },
      costType: "",
    };
  },
  computed: mapGetters(["expressList", "expressModeList"]),
  watch: {
    "ruleForm.feeCalcMode": {
      handler(val) {
        if (val) {
          this.costType = val;
        }
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.queryList();
    this.queryExpressModeList();
    this.queryFeeCalcModeList().then((res) => {
      this.feeCalcModeList = res.result;
    });
  },
  methods: {
    switchTabs() {
      this.queryList();
      // this.$nextTick(() => {
      //   this.$refs.table.doLayout();
      //   //给table加一个ref
      // });
    },
    async queryList() {
      // queryThirdExpressInfoList
      if (this.searchCondition.status === "1") {
        this.$store.dispatch("queryLocalExpressList", {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
        });
      } else {
        const { code, result } = await this.$store.dispatch(
          "queryThirdExpressInfoList"
        );
        if (code === "0") {
          this.thirdExpressInfoList = result;
        }
      }
    },
    queryExpressModeList() {
      this.$store.dispatch("queryExpressModeList");
    },
    queryFeeCalcModeList() {
      return this.$store.dispatch("queryFeeCalcModeList");
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async toDetails(row) {
      this.title = "查看详情";
      this.disabled = true;
      this.dialogVisible = true;
      if (this.searchCondition.status === "1") {
        setTimeout(() => {
          this.init();
        }, 0);
        let params = {
          localExpressId: row.localExpressId,
        };
        this.$store.dispatch("detailsExpress", params).then((res) => {
          if (res.code === "0") {
            for (let key in res.result) {
              if (this.ruleForm.hasOwnProperty(key)) {
                this.ruleForm[key] = res.result[key];
              }
            }

            setTimeout(() => {
              this.init();
            }, 0);
          }
        });
      } else {
        const { code, result } = await this.$store.dispatch(
          "queryThirdExpressInfo",
          { id: row.id }
        );
        if (code === "0") {
          for (let key in result) {
            if (this.ruleFormTree.hasOwnProperty(key)) {
              this.ruleFormTree[key] = result[key];
            }
          }
        }
      }
    },
    async edit(row) {
      this.title = "编辑详情";
      this.disabled = false;
      this.dialogVisible = true;
      if (this.searchCondition.status === "1") {
        setTimeout(() => {
          this.init();
        }, 0);
        let params = {
          localExpressId: row.localExpressId,
        };
        this.$store.dispatch("detailsExpress", params).then((res) => {
          if (res.code === "0") {
            for (let key in res.result) {
              if (this.ruleForm.hasOwnProperty(key)) {
                this.ruleForm[key] = res.result[key];
              }
            }
            setTimeout(() => {
              this.init();
            }, 0);
          }
        });
      } else {
        const { code, result } = await this.$store.dispatch(
          "queryThirdExpressInfo",
          { id: row.id }
        );
        if (code === "0") {
          for (let key in result) {
            if (this.ruleFormTree.hasOwnProperty(key)) {
              this.ruleFormTree[key] = result[key];
            }
          }
        }
      }
    },
    addLocalExpress() {
      if (this.ruleForm.freeType == "") {
        this.ruleForm.freeType = "all";
      }
      this.disabled = false;
      this.dialogVisible = true;
      if (this.searchCondition.status === "1") {
        this.title = "添加同城配送";

        setTimeout(() => {
          this.resetRuleForm();
        }, 0);
        setTimeout(() => {
          this.init();
        }, 0);
      } else {
        this.title = "添加三方";
        setTimeout(() => {
          this.ruleFormTree.id = "";
          this.$refs.ruleFormTree.resetFields();
        }, 0);
      }
    },
    filterGt0OrFixed2(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0OrFixed3(prop) { 
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数      
    },
    feeCalcModeChange(val) {
      this.costType = val;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.ruleForm;

          this.$store
            .dispatch(
              this.title === "添加同城配送"
                ? "saveLocalExpressConfig"
                : "editExpress",
              params
            )
            .then((res) => {
              if (res.code === "0") {
                this.dialogVisible = false;
                this.queryList();
              }
            });
        } else {
          return false;
        }
      });
    },
    submitFormThree(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleFormTree));

          this.$store
            .dispatch(
              this.title === "添加三方"
                ? "saveThirdExpressInfo"
                : "editThirdExpressInfo",
              params
            )
            .then((res) => {
              if (res.code === "0") {
                this.dialogVisible = false;
                this.queryList();
              }
            });
        } else {
          return false;
        }
      });
    },
    init(center, radius) {
      let overlaysArray = []; //覆盖物容器,用于清除覆盖物
      let points = "";
      const { qq } = window;
      if (
        this.ruleForm.regionType === "circular" &&
        this.ruleForm.areaCodeCenter !== ""
      ) {
        let lat = +this.ruleForm.areaCodeCenter.split(",")[0];
        let lng = +this.ruleForm.areaCodeCenter.split(",")[1];
        let centers = new qq.maps.LatLng(lat, lng);
        var map = new qq.maps.Map(document.getElementById("container"), {
          center: centers,
          zoom: 14,
        });

        new qq.maps.Circle({
          map: map,
          center: centers,
          radius: +this.ruleForm.areaCodeRadius,
          strokeWeight: 5,
        });
      } else if (this.ruleForm.regionType === "polygon") {
        let list = JSON.parse(this.ruleForm.areaCodeRegion);

        var map = new qq.maps.Map(document.getElementById("container"), {
          center: new qq.maps.LatLng(list[0].lat, list[0].lng),
          zoom: 14,
        });
        var path = [];
        list.forEach((v) => {
          path.push(new qq.maps.LatLng(v.lat, v.lng));
        });

        new qq.maps.Polygon({
          map: map,
          path: path,
          editable: true,
        });
      } else {
        var map = new qq.maps.Map(document.getElementById("container"), {
          center: new qq.maps.LatLng(30.5993, 114.24831),
          zoom: 14,
        });
      }
      // if (center) {
      //   let lat = +center.split(",")[0];
      //   let lng = +center.split(",")[1];
      //   let centers = new qq.maps.LatLng(lat, lng);
      //   var map = new qq.maps.Map(document.getElementById("container"), {
      //     center: centers,
      //     zoom: 14
      //   });

      //   new qq.maps.Circle({
      //     map: map,
      //     center: centers,
      //     radius: +radius,
      //     strokeWeight: 5
      //   });
      // } else {
      //   var map = new qq.maps.Map(document.getElementById("container"), {
      //     center: new qq.maps.LatLng(30.5993, 114.24831),
      //     zoom: 14
      //   });
      // }

      var drawingManager = new qq.maps.drawing.DrawingManager({
        drawingMode: qq.maps.drawing.OverlayType.CIRCLE,
        drawingControl: true,
        drawingControlOptions: {
          position: qq.maps.ControlPosition.TOP_CENTER,
          drawingModes: [
            // qq.maps.drawing.OverlayType.MARKER,
            qq.maps.drawing.OverlayType.CIRCLE,
            qq.maps.drawing.OverlayType.POLYGON,
            // qq.maps.drawing.OverlayType.POLYLINE,
            // qq.maps.drawing.OverlayType.RECTANGLE
          ],
        },
        circleOptions: {
          fillColor: new qq.maps.Color(255, 208, 70, 0.3),
          strokeColor: new qq.maps.Color(88, 88, 88, 1),
          strokeWeight: 3,
          clickable: false,
        },
      });
      drawingManager.setMap(map);
      qq.maps.event.addListener(
        drawingManager,
        "overlaycomplete",
        function (event) {
          if (event.type == "circle") {
            // this.ruleForm.regionType = "circular";
            clearOverlays(overlaysArray);
            overlaysArray.push(event.overlay);
            var latLng = event.overlay.getCenter();
            var newRadius = event.overlay.getRadius();
            let lat = latLng.getLat().toFixed(5);
            let lng = latLng.getLng().toFixed(5);
            var center = new qq.maps.LatLng(lat, lng);
            var geocoder = new qq.maps.Geocoder();
            geocoder.getAddress(latLng);
            //设置服务请求成功的回调函数

            geocoder.setComplete(function (result) {
              doMarker(center, result.detail.address + latLng);
              getPeopleDataByCircle(newRadius, lat + "," + lng);
            });

            //若服务请求失败，则运行以下函数
            geocoder.setError(function () {
              alert("出错了，请输入正确的经纬度！！！");
            });
          } else if (event.type == "polygon" || event.type == "rectangle") {
            clearOverlays(overlaysArray);
            overlaysArray.push(event.overlay);

            let list = [];
            event.overlay.getPath().forEach(function (e) {
              var lng = e.getLng().toFixed(6);
              var lat = e.getLat().toFixed(6);
              list.push({ lng: lng, lat: lat });
              points += lng + " " + lat + ",";
            });

            points = points.substring(0, points.length - 1);
            getPeopleDataByPolygon(JSON.stringify(list));
          }
        }
      );
      //查询圆数据
      let that = this;
      function getPeopleDataByCircle(radius, center) {
        // alert("圆形中心为:" + center + "半径为:" + radius);
        that.ruleForm.regionType = "circular";
        that.ruleForm.areaCodeCenter = center;
        that.ruleForm.areaCodeRadius = radius;
      }

      //查询多边形数据
      function getPeopleDataByPolygon(points) {
        that.ruleForm.regionType = "polygon";
        that.ruleForm.areaCodeRegion = points;
      }

      //清除覆盖物
      function clearOverlays(overlaysArray) {
        if (overlaysArray) {
          overlaysArray.forEach((v, i) => {
            overlaysArray[i].setMap(null);
          });
        }
      }
      //画圆中心点
      function doMarker(center, title) {
        //创建一个Marker
        var marker = new qq.maps.Marker({
          //设置Marker的位置坐标
          position: center,
          //设置显示Marker的地图
          map: map,
          title: title,
        });

        //设置Marker的可见性，为true时可见,false时不可见，默认属性为true
        marker.setVisible(false);
        //设置Marker的动画属性为从落下
        marker.setAnimation(qq.maps.MarkerAnimation.DOWN);
        overlaysArray.push(marker);
        marker.setMap(map);
      }
      //画圆
      function doCircle(center) {
        var circle = new qq.maps.Circle({
          map: map,
          center: center,
          radius: radius,
          strokeWeight: 5,
        });
        overlaysArray.push(circle);
        circle.setMap(map);
      }
    },
    resetRuleForm() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
      if (this.$refs.ruleForm) {
        this.$refs.ruleFormTree.resetFields();
      }
      this.ruleForm.feeCalcMode = "";
      this.ruleForm.lowerLimitAmount = "";
      this.ruleForm.expressFee = "";
      this.ruleForm.freeShipAmount = "";
      this.ruleForm.baseDistanceUpperLimit = "";
      this.ruleForm.overPerkmPrice = "";
      this.ruleForm.baseWeightUpperLimit = "";
      this.ruleForm.overPerkgPrice = "";
      this.ruleForm.areaCodeRange = "yes";
      this.ruleForm.enabledState = "no";
      this.ruleForm.areaCodeCenter = "";
      this.ruleForm.areaCodeRadius = "";
      this.ruleForm.localExpressId = "";
      this.ruleForm.regionType = "circular";
      this.ruleForm.areaCodeRegion = "";
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
